module.exports = __webpack_public_path__ + "img/12.c678f068.jpg";